export default __webpack_public_path__ + "static/media/9.b31dd5f8.jpg";